module.exports = __webpack_public_path__ + "img/6.bbb7fb48.jpg";